module.exports = __webpack_public_path__ + "media/store/fonts/Fatype-Regular-fea409d924d4faa2a3d63d94ea8454b3.otf";